<template>
    <csp-loading-indicator v-if="isLoading" class="global-loading-indicator"/>
</template>

<script>
    export default {
        computed: {
            isLoading() {
                return this.$root.loadingState.isLoading;
            },
        },
    }
</script>
